export const setTranslatableColumnStmtInstruction = `
#### Set translatable column

- Syntax: \`translatable column <entity_name>.<column_name>;\`
- Example: \`translatable column Article.createdAt;\`
`;
export const stmtSetTranslatableColumn = ({ entityName, fieldName }) => {
    return `translatable column ${entityName}.${fieldName};`;
};
//# sourceMappingURL=SetTranslatableColumnStmt.js.map